import { render } from "./ClientHomepage.vue?vue&type=template&id=5c3482b6&scoped=true"
import script from "./ClientHomepage.vue?vue&type=script&lang=js"
export * from "./ClientHomepage.vue?vue&type=script&lang=js"

import "./ClientHomepage.vue?vue&type=style&index=0&id=5c3482b6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3482b6"]])

export default __exports__